import React from "react";
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import "./MarketsServed.css";
import residentialImg from "../../../../assets/images/residential.jpg";
import commercialImg from "../../../../assets/images/commercial.jpg";
import municipalImg from "../../../../assets/images/municipal.png";
import industrialImg from "../../../../assets/images/industrial.jpg";
// import residentialIcon from "../../../../assets/images/residential-icon.png";
import commercialIcon from "../../../../assets/images/icons/commercial-icon.svg";
import municipalIcon from "../../../../assets/images/icons/muncipal-icon.svg";
import industrialIcon from "../../../../assets/images/icons/industrial-icon.svg";
import { useHomeStore } from "../../../../store/useHomeStore";

const markets = [
  {
    key: "residential",
    title: "Residential",
    description:
      "Reliable grading and site prep for homebuilders, subdivisions, and custom residential developments.",
    image: residentialImg,
    // icon: residentialIcon,
    icon: industrialIcon,

  },
  {
    key: "commercial",
    title: "Commercial",
    description:
      "Expert site development for offices, retail centers, warehouses, and other commercial construction projects.",
    image: commercialImg,
    icon: commercialIcon,
  },
  {
    key: "municipal",
    title: "Municipal",
    description:
      "Supporting public works with dependable grading and utilities services for local governments.",
    image: municipalImg,
    icon: municipalIcon,
  },
  // {
  //   key: "industrial",
  //   title: "Industrial",
  //   description:
  //     "Heavy-duty site preparation and grading for plants, factories, and industrial development projects.",
  //   image: industrialImg,
  //   icon: industrialIcon,
  // },
];


const MarketsServed = () => {
  const { marketArea } = useHomeStore()

  return (
    <section className="markets-served-section bg-light-gray">
      <Container className="theme-container">
        <div className="section-header">
          <p className="section-subtitle">{marketArea?.subTitle}</p>
          <h3>{marketArea?.title}</h3>
          <p className="description fs-6 mt-xl-4 mt-2 mb-xl-4 mb-2">
            {marketArea?.description}
          </p>
        </div>

        <Row className="g-4 market-served-content-row justify-content-center align-items-center">
          {(marketArea?.area || []).map((market, i) => (
            <Col md={6} lg={4} key={market.key}>
              <div className="market-card">
                <div className="market-img-wraper">
                  <img src={market?.image} alt={market?.title} className="market-image" />
                </div>
                <div className="market-title d-flex align-items-center gap-2">
                  <img src={markets[i]?.icon} alt={`${market?.title} icon`} className="market-icon" />
                  <h6 className="mb-0">{market?.title}</h6>
                </div>
                <p className="market-description fs-6">{market?.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default MarketsServed;
